import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Link from 'components/Link';
import TeasePicture from 'components/TeasePicture';
import TypeIcon from 'components/TypeIcon';
import Unibrow from 'components/Unibrow';

import AIMS_FLAVORS from 'lib/aimsFlavors';
import {
  content as ContentPropType,
  packageContext as packageContextTypes,
} from 'lib/CustomPropTypes';
import { imageAltForItem } from 'lib/imageAlt';
import { getTeaseUrl } from 'lib/teaseUtils';
import { getVerticalName } from 'lib/verticalType';

function ALaCarteItem(props, context) {
  const { featured, item } = props;
  const { vertical, railContext } = context;

  const {
    computedValues,
    id,
    metadata,
    type,
  } = item;

  const {
    headline,
    url,
    unibrow,
  } = computedValues || {};

  const isInRail = railContext !== null;
  const isOpinion = getVerticalName(item) === 'think';
  const isFeatured = featured;
  const isSquareImage = !isFeatured;
  const isRoundedImage = vertical === 'today' && isInRail && !isFeatured;

  const imageUrl = getTeaseUrl(item, isSquareImage);
  const shouldDisplayImage = !!imageUrl && metadata.showTeaseImage !== false;
  const imageAlt = imageAltForItem(item);

  let imageSizes = { s: AIMS_FLAVORS.FOCAL_80x80 };
  if (isFeatured) {
    imageSizes = {
      s: AIMS_FLAVORS.FOCAL_720x360,
      m: AIMS_FLAVORS.FOCAL_200x100,
      l: AIMS_FLAVORS.FOCAL_280x140,
      xl: AIMS_FLAVORS.FOCAL_260x130,
    };
  }

  return (
    <li
      key={id}
      data-contentid={id}
      className={classNames(
        'alacarte__item',
        {
          'alacarte__item--no-art': !shouldDisplayImage,
          'alacarte__item--opinion': isOpinion,
          'alacarte__item--featured': isFeatured,
        },
      )}
      data-test="alacarte__item"
    >
      {shouldDisplayImage && (
        <div className="alacarte__image-wrapper" data-test="alacarte__image-wrapper">
          <Link to={url}>
            <TypeIcon type={type} className="alacarte__type-icon" />
            <TeasePicture
              alt={imageAlt}
              className={classNames({ 'alacarte__image--radius': isRoundedImage })}
              preview={type === 'video' && { url, redirect: false, radius: isRoundedImage }}
              responsiveFlavors={imageSizes}
              retina
              url={imageUrl}
            />
          </Link>
        </div>
      )}
      <div>
        {shouldDisplayImage && (
          <Unibrow
            className="alacarte__unibrow"
            data-test="alacarte__unibrow"
            unibrow={unibrow}
          />
        )}
        <Link to={url}>
          <h2 className="alacarte__headline" data-test="alacarte__headline">
            {headline}
          </h2>
        </Link>
      </div>
    </li>
  );
}

ALaCarteItem.propTypes = {
  featured: PropTypes.bool,
  item: ContentPropType.isRequired,
};

ALaCarteItem.defaultProps = {
  featured: false,
};

ALaCarteItem.contextTypes = {
  vertical: PropTypes.string,
  ...packageContextTypes,
};

export default ALaCarteItem;
